import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateChat } from '../apis/chatApi';
import { UpdateChatRequest } from '../apis/types';

export const useRenameChat = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ chatId, title }: { chatId: string; title: string }) => {
      const token = await getAccessTokenSilently();
      const updateData: UpdateChatRequest = { title };
      return updateChat(chatId, updateData, token);
    },
    onSuccess: () => {
      // Invalidate and refetch chats list
      queryClient.invalidateQueries({ queryKey: ['chats'] });
    },
    onError: (error) => {
      console.error('Error renaming chat:', error);
    },
  });

  return {
    renameChat: mutation.mutateAsync,
    isRenaming: mutation.isPending,
    error: mutation.error,
  };
};